module.exports = __webpack_public_path__ + "media/images/emblems/Romont_BE-coat_of_arms-dcea8917e37caa1c0534a45d9e5e0247.svg";